import { Injectable } from '@angular/core';
import {
  GetMinimumChargesForCzarLiteTariffResp,
  GetMinimumChargesForCzarLiteTariffRqst,
  SendTariffRatesFileRqst,
  TariffManagementApiService,
  TariffRateChange,
  UpdateTariffRateResp,
  UpdateTariffRateRqst,
  UploadTariffAmcFilePath,
  UploadTariffAmcFileResp,
} from '@xpo-ltl/sdk-tariffmanagement';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TariffService {
  constructor(public tariffManagementApiService: TariffManagementApiService) {}

  updateTariffRate(tariffRateChange: TariffRateChange): Observable<UpdateTariffRateResp> {
    const request = new UpdateTariffRateRqst();
    request.tariffRateChange = tariffRateChange;
    return this.tariffManagementApiService.updateTariffRate(request);
  }

  sendTariffRatesFile(request: SendTariffRatesFileRqst): Observable<void> {
    return this.tariffManagementApiService.sendTariffRatesFile(request);
  }

  getMinimumChargesForCzarLiteTariff(
    request: GetMinimumChargesForCzarLiteTariffRqst
  ): Observable<GetMinimumChargesForCzarLiteTariffResp> {
    return this.tariffManagementApiService.getMinimumChargesForCzarLiteTariff(request);
  }

  uploadAmcFile(tariff: string, effectiveDate: string, file): Observable<UploadTariffAmcFileResp> {
    const formData: FormData = new FormData(),
      pathParams = new UploadTariffAmcFilePath();
    formData.append('file', file);
    formData.append('effectiveDate', effectiveDate);
    pathParams.tariff = tariff;
    return this.tariffManagementApiService.uploadTariffAmcFile(formData as any, pathParams);
  }
}
